import { useEventContext } from 'context/EventContext'
import EventAsset from './EventAsset'

function EventAssets() {
  const { event } = useEventContext()

  const assets = event.assets
  if (!assets.length) {
    return null
  }

  return (
    <div className="grid gap-y-8 grid-cols-2 sm:grid-cols-4 gap-x-8 pb-4 px-4">
      {assets.map(asset => (
        <EventAsset
          key={`asset-${asset.id}`}
          asset={asset}
          isPrivileged={event.isPrivileged}
        />
      ))}
    </div>
  )
}

export default EventAssets
